/**
 * Header Navigation
 * Handles active link state based on current URL
 * Desktop-only, minimal logic
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeader);
  } else {
    initHeader();
  }

  function initHeader() {
    const currentPath = window.location.pathname;
    const navLinks = document.querySelectorAll('.nav-link');

    // Set active state based on current path
    navLinks.forEach(link => {
      const linkPath = new URL(link.href, window.location.origin).pathname;
      
      // Exact match for home page
      if (currentPath === '/' && linkPath === '/') {
        link.setAttribute('aria-current', 'page');
      }
      // Partial match for other pages
      else if (currentPath !== '/' && linkPath !== '/' && currentPath.startsWith(linkPath)) {
        link.setAttribute('aria-current', 'page');
      }
      // Remove aria-current if not active
      else {
        link.removeAttribute('aria-current');
      }
    });

    // Add keyboard navigation enhancements
    enhanceKeyboardNav();
  }

  function enhanceKeyboardNav() {
    const header = document.querySelector('.site-header');
    if (!header) return;

    const focusableElements = header.querySelectorAll(
      'a[href], button:not([disabled])'
    );

    if (focusableElements.length === 0) return;

    // Enable arrow key navigation between nav items
    focusableElements.forEach((element, index) => {
      element.addEventListener('keydown', (e) => {
        let targetIndex;

        switch(e.key) {
          case 'ArrowRight':
            targetIndex = index + 1;
            if (targetIndex >= focusableElements.length) targetIndex = 0;
            break;
          case 'ArrowLeft':
            targetIndex = index - 1;
            if (targetIndex < 0) targetIndex = focusableElements.length - 1;
            break;
          default:
            return;
        }

        e.preventDefault();
        focusableElements[targetIndex].focus();
      });
    });
  }

  // Export for potential external use
  window.HeaderNav = {
    init: initHeader
  };
})();

